import { QueryKeysEnum } from '@/enums';
import {
  CreateQcAlertLogPayload,
  QcAlertLogEntity,
  QcAlertLogParam,
} from '@/types';
import APIService from './axios.service';
import { BaseService } from './base.service';

class QcAlertLogService extends BaseService<
  'qcAlertLog',
  QcAlertLogEntity,
  CreateQcAlertLogPayload
> {
  constructor() {
    super(QueryKeysEnum.QC_ALERT_LOG);
  }

  getByQcAlertId = (params: QcAlertLogParam): Promise<QcAlertLogEntity[]> => {
    return APIService.get(this.path, { params });
  };
}

export const qcAlertLogService = new QcAlertLogService();
